
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { usePermissions } from "@/hooks/use-permissions";

interface Country {
  id: string;
  code: string;
  name: string;
  active: boolean;
  background_image_url?: string | null;
  background_image_alt?: string | null;
  created_at?: string;
  updated_at?: string;
}

export const useCountries = () => {
  const { isSuperAdmin, getAssignedCountries } = usePermissions();

  const { data, isLoading, error } = useQuery({
    queryKey: ['countries'],
    queryFn: async () => {
      let query = supabase
        .from('countries')
        .select('*')
        .order('name');

      // Apply country filtering for non-super admins
      if (!isSuperAdmin()) {
        const assignedCountries = getAssignedCountries();
        if (assignedCountries.length > 0) {
          query = query.in('code', assignedCountries);
        } else {
          // No assigned countries - return empty array
          return [] as Country[];
        }
      }
        
      const { data, error } = await query;
      
      if (error) throw error;
      
      // Map the data to include id property (using code as id)
      return data?.map(country => ({
        ...country,
        id: country.code // Use code as id for consistency
      })) as Country[] || [];
    }
  });

  return {
    countries: data || [],
    isLoading,
    error
  };
};
